<template>
	<div
		class="g-block-title-left-bar g-block-title-padding"
		:class="{
			'g-block-title-left-bar--edit': editable,
			'is-active': editable && active,
			'g-block-title-left-bar--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-left-bar__row">
			<span class="g-block-title-left-bar__bar" :style="{ background: themeColor }"></span>
			<RichTextEditable
				v-if="editable"
				class="g-block-title-left-bar__text"
				fit-content
				:style="{ color: themeColor }"
				:model-value="data.content"
				placeholder="请输入标题"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-title-left-bar__text"
				:style="{ color: themeColor }"
				v-html="data.content || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleLeftBar',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-left-bar {
		.title-block-edit-shell();
	}

	.g-block-title-left-bar__row {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.g-block-title-left-bar__bar {
		width: 6px;
		height: 22px;
		flex-shrink: 0;
		border-radius: 1px;
	}

	.g-block-title-left-bar__text {
		font-size: 20px;
		font-weight: 700;
		line-height: 1.3;
		:deep(.g-rich-text-editable__content) { min-height: unset; padding: 0; font-weight: 700; }
	}

	.g-block-title-left-bar--h5 {
		.g-block-title-left-bar__row { gap: 0.24rem; }
		.g-block-title-left-bar__bar { width: 0.12rem; height: 0.44rem; }
		.g-block-title-left-bar__text { font-size: 0.4rem; }
	}
</style>
